import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from '../../../../../models/hooks';
import { MultiOption, MultiSelect } from './MultiSelect';

function SelectDistrictComponent() {
  const { t } = useTranslation('moniterByRecruiters');

  const { districts, positionFilters, isFetchingBusinessAddress } = useStoreState(
    /* istanbul ignore next */ (state) => state.moniterByRecruiters,
  );
  const { setPositionFilter } = useStoreActions(/* istanbul ignore next */ (state) => state.moniterByRecruiters);

  const handleDistrictSelectionChange = useCallback(
    (values: string[], selectAll: boolean) => {
      if (values.length <= 0 || selectAll) {
        setPositionFilter({ key: 'isAllLocationsSelected', value: true });
        return;
      }
      setPositionFilter({ key: 'isAllLocationsSelected', value: false });

      const selectedDistricts = Array.from(
        new Set(
          Object.entries(districts || {})
            .filter(([key]) => values?.includes(key))
            .reduce((acc, [, dist]) => [...acc, ...dist], [] as string[]),
        ),
      );

      if (selectedDistricts.length) {
        setPositionFilter({ key: 'businessIds', value: selectedDistricts });
      }
    },
    [setPositionFilter, districts],
  );

  // Map locations to generic options
  const districtOptions: MultiOption<string>[] = React.useMemo(
    () =>
      Object.keys(districts || {})?.map((dist) => ({
        value: dist,
        label: dist,
      })),
    [districts],
  );

  return (
    <MultiSelect
      options={districtOptions}
      selectedValues={positionFilters.district ?? []}
      onChange={(vals, selectAll) => {
        setPositionFilter({ key: 'isAllDistrictSelected', value: selectAll });
        setPositionFilter({ key: 'district', value: vals });
        setTimeout(() => handleDistrictSelectionChange(vals, selectAll), 0);
      }}
      selectAll={positionFilters.isAllDistrictSelected}
      label={t('filter.district.label')}
      allSelectText={t('filter.district.all')}
      placeholder={t('filter.district.search')}
      isLoading={isFetchingBusinessAddress}
      height={400}
      itemHeight={30}
    />
  );
}

export const SelectDistrict = React.memo(SelectDistrictComponent);
